<template>
  <div>
    <modal
      :show.sync="modal"
      body-classes="p-0"
      modal-classes="modal-dialog-centered modal-lg">
      <template slot="header">
        <h5 class="modal-title">消息通知</h5>
      </template>
      <div id="notification_list" class="m-3">
        <ul class="list-group card-list-group">
          <li class="list-group-item">
            <div class="media">
              <!-- <div class="media-object avatar avatar-md mr-4"><img src="/img/icons/lueying.png" alt="lueying"></div> -->
              <div class="media-body" >
                <div class="media-heading"><small class="float-right text-muted">2020-04-09</small><h5>更新</h5>
                </div>
                <div style="font-size: 0.9rem">
                  <ul>
                    <li>新增J套餐线路，保证线路通顺！</li>
                    <li>优化配置教程，更新教程文档</li>
                    <li>更新客户端版本到最新</li>
                    <li>更多细节优化...</li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="media">
              <!-- <div class="media-object avatar avatar-md mr-4"><img src="/img/icons/lueying.png" alt="lueying"></div> -->
              <div class="media-body" >
                <div class="media-heading"><small class="float-right text-muted">2019-08-09</small><h5>更新</h5>
                </div>
                <div style="font-size: 0.9rem">
                  <ul>
                    <li>新增C套餐线路，保证线路通顺！</li>
                    <li>更新客户端版本到最新</li>
                    <li>更多细节优化...</li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="media">
              <!-- <div class="media-object avatar avatar-md mr-4"><img src="/img/icons/lueying.png" alt="lueying"></div> -->
              <div class="media-body" >
                <div class="media-heading"><small class="float-right text-muted">2019-06-30</small><h5>更新</h5>
                </div>
                <div style="font-size: 0.9rem">
                  <ul>
                    <li>增加ios 一键导入功能，方便 ShadowRocket， Quantumult 用户的使用设置</li>
                    <li>增加修改账号订阅连接的修改，保护账号隐私</li>
                    <li>修改账号列表页面展示，更清晰的查看账号使用情况</li>
                    <li>更多细节优化...</li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="media">
              <!-- <div class="media-object avatar avatar-md mr-4"><img src="/img/icons/lueying.png" alt="lueying"></div> -->
              <div class="media-body" >
                <div class="media-heading"><small class="float-right text-muted">2019-03-28</small><h5>数据丢失通告</h5>
                </div>
                <div style="font-size: 0.9rem">
                  <ul>
                    <li>由于技术人员操作不当，导致2019-03月份所有数据丢失</li>
                    <li>造成所有用户订阅连接失效，配置不可用</li>
                    <li>凡是在三月份下单支付的，特补偿有效时长一月有效期。</li>
                    <li>可凭借支付截图，登陆账号发送邮件给客服</li>
                    <li><h6 style="margin:12px 0">客服邮箱：<a style="margin:0 12px" href="mailto:admin@sstz.me">admin@sstz.me</a></h6></li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="media">
              <!-- <div class="media-object avatar avatar-md mr-4"><img src="/img/icons/lueying.png" alt="lueying"></div> -->
              <div class="media-body" >
                <div class="media-heading"><small class="float-right text-muted">2018-03-14</small><h5>新增【基础套餐B】通知</h5>
                </div>
                <div style="font-size: 0.9rem">
                  <ul>
                    <li>目前【基础套餐A】已经售罄！</li>
                    <li>新增【基础套餐B】！</li>
                    <li>此套餐配置完全和套餐A相同,大家可放心购买使用！</li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="media">
              <!-- <div class="media-object avatar avatar-md mr-4"><img src="/img/icons/lueying.png" alt="lueying"></div> -->
              <div class="media-body" >
                <div class="media-heading"><small class="float-right text-muted">2017-05-06</small><h5>全面升级V2ray通知</h5>
                </div>
                <div style="font-size: 0.9rem">
                  <ul>
                    <li>因Shadowsocks特征太明显，现将本站所有服务升级到V2ray</li>
                    <li>为补偿您的损失，特奉上7折优惠码：sstz@2019</li>
                    <li>有效期到 2019-03-15 00:00:00</li>
                    <li>在此过程对您造成的影响，感到非常的抱歉！</li>
                    <li>客服Email: <a href="mailto:admin@sstz.me"> admin@sstz.me</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </modal>
  </div>
</template>
<script>
// import moment from 'moment'
import { mapActions } from 'vuex'
import Modal from '@/components/Modal.vue'
export default {
  name: 'LoginForm',
  components: {
    Modal
  },
  data() {
    return {
      modal: false
    }
  },
  methods: {
    ...mapActions([
      'repassword'
    ]),
    open() {
      this.modal = true
    },
    close() {
      this.modal = false
    }
  }
}
</script>
<style>
</style>
